import { ApiClient } from './api/client'

import { log } from '../log'

export class AddressService {

  static async get(zipcode: string, fallback: boolean = false): Promise<AddressInfo> {
    try {
      const response = await ApiClient.get('/api/address/search')
        .query({
          zipcode,
          fallback,
        })

      const code = response.body.statuscode

      // tslint:disable-next-line
      if (code !== 200) {
        const { message } = response.body
        throw new Error(JSON.stringify(message))
      }

      const data = !fallback ? response.body.data : response.body.results

      if (data.length === 0) {
        throw new Error('No Match Data.')
      }

      const addressData = fallback ? data[0].address_components : data[0]

      const addressComponentLengthLong = 6
      const isLongAddress = addressData.length === addressComponentLengthLong
      const indexPrefLong = 4
      const indexPrefShort = 3
      const indexCityLong = 3
      const indexCityShort = 2

      const indexPref = isLongAddress ? indexPrefLong : indexPrefShort
      const indexCity = isLongAddress ? indexCityLong : indexCityShort
      const indexState = 2
      const indexTown = 1

      const addressInfo: AddressInfo = !fallback ? {
        prefecture: addressData.state,
        city: addressData.town,
        town: addressData.street,
      } : {
        prefecture: addressData[indexPref].long_name,
        city: addressData[indexCity].long_name + isLongAddress ? addressData[indexState].long_name : '',
        town: addressData[indexTown].long_name,
      }

      return addressInfo

    } catch (error) {
      log.error(error)
      if (fallback) {
        throw error
      }

      return AddressService.get(zipcode, true)
    }
  }

}

export interface AddressInfo {
  prefecture: string
  city: string
  town: string
}
